import React from 'react';
import { Route } from "react-router-dom";
import Nav from "@/components/Nav";
import Favorable from '@/components/favorable/index';

const PromotionPage = ({ match }) => (
  <React.Fragment>
    <Nav />
    <Route path={`${match.url}`} component={Favorable}/>
  </React.Fragment>
);
export default PromotionPage;